import {
    Component,
    ViewEncapsulation,
    OnInit,
    Input,
    Output,
    EventEmitter,
    forwardRef,
    ChangeDetectionStrategy
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { COLOR_NAMES } from '../../../constants';

export interface ColorItem {
    name: string;
    color: string;
    n_color: string;
}

@Component({
    selector: 'styx-color-select',
    templateUrl: './color-select.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StyxColorSelectComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StyxColorSelectComponent implements OnInit, ControlValueAccessor {
    public colorNames = COLOR_NAMES;

    public color = COLOR_NAMES[0].color;

    @Output() colorSelect: EventEmitter<any> = new EventEmitter<any>();

    constructor() {}

    ngOnInit() {}

    onSelect(item: ColorItem) {
        this.color = item.color;
        this.onModelChange(item.color);
        this.colorSelect.emit({ color: item.color });
    }

    private onModelChange: Function = () => {};

    private onModelTouched: Function = () => {};

    writeValue(value: any) {
        if (value) {
            this.color = value;
            return;
        }
        this.color = this.colorNames[0].color;
        this.onModelChange(this.color);
    }

    // tslint:disable-next-line:ban-types
    registerOnChange(fn: Function): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }
}
